<div class="row mb-3">
  <div class="col-8 col-lg-8">
    <mat-label class="heading">{{ "editLicense" | translate }}</mat-label>
  </div>
  <div class="col-4 col-lg-4">
    <div class="d-flex justify-content-end">
      <mat-icon (click)="closeNotif()">close</mat-icon>
    </div>
  </div>
</div>
<form [formGroup]="licenseFormGroup">
  <div class="contiainer">
    <div class="row">
      <div class="col-lg-12 mb-2">
        <mat-form-field appearance="outline" [style.width.%]="100">
          <mat-label>{{ "eligibilityLicense" | translate }}</mat-label>
          <mat-select formControlName="licenseType" [(ngModel)]="selectedLicenseType"
            (selectionChange)="currentLicenseType()">
            <mat-option *ngFor="let licenseType of licenseTypes" [value]="licenseType.name">
              {{ licenseType.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row" *ngIf="selectedLicenseType == 'Professional Regulation Commission (PRC)'">
      <div class="col-lg-7 mb-2">
        <mat-form-field appearance="outline" [style.width.%]="100">
          <mat-label>{{ "prcLicense" | translate }}</mat-label>
          <input matInput formControlName="prc" appNoLeadingSpaces />
        </mat-form-field>
        <mat-hint>ex: Physician, Electronics Engineer, Criminologist</mat-hint>
      </div>
      <div class="col-lg-5 mb-2">
        <mat-form-field appearance="outline" [style.width.%]="100">
          <mat-label>{{ "validUntil" | translate}}</mat-label>
          <input matInput [matDatepicker]="picker" [min]="minDate" readonly formControlName="validUntilDate" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <div class="row" *ngIf="selectedLicenseType == 'Civil Service Commission  (CSC)'">
      <div class="col-lg-12 mb-2">
        <mat-form-field appearance="outline" [style.width.%]="100">
          <mat-label>{{ "eligibilityLevel" | translate }}</mat-label>
          <mat-select formControlName="eligibilityLevel">
            <mat-option *ngFor="let civilServiceLevel of civilServiceLevels" [value]="civilServiceLevel.name">
              {{ civilServiceLevel.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-6 mb-2">
        <mat-form-field appearance="outline">
          <mat-label>{{ "monthTaken" | translate }}</mat-label>
          <mat-select formControlName="takenDateMonth">
            <mat-option *ngFor="let month of filteredMonths" value="{{ month.viewValue }}">{{ month.viewValue
              }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ "yearTaken" | translate }}</mat-label>
          <mat-select formControlName="takenDateYear">
            <mat-option *ngFor="let year of years" value="{{ year }}">{{ year
              }}</mat-option>
          </mat-select>
          <!-- <input matInput formControlName="takenDateYear"> -->
        </mat-form-field>
      </div>
      <!-- <div class="col-lg-12 mb-2">
        <mat-form-field appearance="outline" [style.width.%]="100">
          <mat-label>Date Taken</mat-label>
          <input
            matInput
            [matDatepicker]="picker"
            readonly
            formControlName="takenDate"
            [max]="maxDate" 
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div> -->
    </div>

    <div class="row mt-1">
      <div *ngIf="successMessage" class="success-message">
        {{ "successMessageUpdateLicense" | translate }}
      </div>
      <div *ngIf="errorMessage" class="error-message">
        {{ "errorMessage" | translate }}
      </div>
    </div>

    <mat-progress-bar mode="indeterminate" *ngIf="isLicenseUpdated"></mat-progress-bar>

    <div class="row mt-3 mb-1">
      <div class="col-12 col-lg-12">
        <div class="d-flex justify-content-end">
          <div class="col-12 col-lg-auto">
            <button mat-raised-button color="primary" class="text-white" (click)="updateLicense()"
              [disabled]="isLicenseDisabled">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>